import {
  Alert,
  Box,
  Button,
  Divider,
  IconButton,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useContext, useState } from "react";
import { DropzoneArea } from "react-mui-dropzone";
import { UserInfo } from "../../../../context";
import Close from "@mui/icons-material/Close";

const EditProduct = ({
  getProductList,
  close,
  merchant_id,
  categoryList,
  data,
}) => {
  const { setIsProcess, isProcess, setMessage, setSeverity, setOpenSnackbar } =
    useContext(UserInfo);
  const [image, setImage] = useState([]);
  const [openSnack, setOpenSnack] = useState(false);

  const handleEditProduct = (e) => {
    e.persist();
    e.preventDefault();
    var formdata = new FormData(e.target);
    formdata.append("id", data && data?.id !== null ? data?.id : "");
    formdata.append("merchant_id", merchant_id);
    formdata.append("image", image.length > 0 ? image[0] : "empty");
    formdata.append(
      "old_image",
      data && data?.product_image !== null ? data?.product_image : ""
    );
    var err = [];
    if (data && data?.product_image === null) {
      if (image.length < 1) {
        err = "error";
        setOpenSnack(true);
      }
    }
    if (err.length > 0) {
      console.log("form has a problem!");
    } else {
      setIsProcess(true);
      close();
      axios
        .post("user/merchant/update/product", formdata)
        .then((response) => {
          const data = response.data;
          if (data === "success") {
            setMessage("Successfully update product");
            setSeverity("success");
            setTimeout(() => {
              setIsProcess(false);
              setOpenSnackbar(true);
              setTimeout(() => {
                getProductList();
              }, 500);
            }, 1000);
          }
        })
        .catch((error) => {
          setIsProcess(false);
          console.log("error", error);
        });
    }
  };

  const handleImageChangeNew = (files) => {
    setImage(files);
  };

  return (
    <>
      <Box sx={{ m: 2 }}>
        <form onSubmit={handleEditProduct} encType="multipart/form-data">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box flexGrow={1}>
              <Typography sx={{ fontWeight: 700 }}>Edit Product</Typography>
            </Box>
            <IconButton size="small" onClick={() => close()}>
              <Close />
            </IconButton>
          </Box>

          <Divider />

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 2,
              mb: 2,
            }}
          >
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              label="Product Name"
              fullWidth
              name="product"
              defaultValue={data && data?.product !== null ? data?.product : ""}
              required
              multiline
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 2,
            }}
          >
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              label="Product Description"
              fullWidth
              name="description"
              defaultValue={
                data && data?.description !== null ? data?.description : ""
              }
              multiline
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 2,
            }}
          >
            <TextField
              select
              SelectProps={{ native: true }}
              InputLabelProps={{
                shrink: true,
              }}
              label="Product Category"
              fullWidth
              name="category"
              defaultValue={
                data && data?.category !== null ? data?.category : ""
              }
              required
            >
              <option value=""> - Select category - </option>
              {categoryList.data.map((data, index) => (
                <option key={index} value={data.id}>
                  {data.category}
                </option>
              ))}
            </TextField>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 2,
            }}
          >
            <TextField
              InputProps={{
                disableunderline: "true",
                inputProps: {
                  min: 1,
                  max: 99999999999,
                  step: 0.01,
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
              label="Product Price"
              fullWidth
              name="price"
              defaultValue={data && data?.price !== null ? data?.price : ""}
              required
              type="number"
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 2,
            }}
          >
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              label="Product Unit"
              fullWidth
              name="unit"
              defaultValue={data && data?.unit !== null ? data?.unit : ""}
              multiline
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <DropzoneArea
              onChange={handleImageChangeNew}
              acceptedFiles={["image/jpeg", "image/png"]}
              dropzoneText={"Upload product image"}
              maxFileSize={2000000}
              filesLimit={1}
              dropzoneClass={"dropZoneCustom"}
              dropzoneParagraphClass={"dropZoneCustomText"}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
            }}
          >
            <Box flexGrow={1} />
            <Box>
              <Button
                variant="contained"
                size="large"
                sx={{
                  textTransform: "capitalize",
                  borderRadius: 2,
                  // fontSize: 12,
                  paddingX: 2,
                  backgroundColor:
                    process.env.REACT_APP_APP_NAME === "estherph"
                      ? "#261138"
                      : "#ff9f1d",
                }}
                type="submit"
                disabled={isProcess}
              >
                Save
              </Button>
            </Box>
          </Box>
        </form>
      </Box>

      <Snackbar
        open={openSnack}
        autoHideDuration={3000}
        onClose={(event, reason) => {
          if (reason === "clickaway") {
            return;
          }
          setOpenSnack(false);
        }}
      >
        <Alert
          onClose={(event, reason) => {
            if (reason === "clickaway") {
              return;
            }
            setOpenSnack(false);
          }}
          severity="error"
          sx={{ width: "100%" }}
        >
          Image of the product is required
        </Alert>
      </Snackbar>
    </>
  );
};

export default EditProduct;
